<template>
  <nav
    :class="{'l-0': isExpanded }"
    class="
      header-navbar
      navbar navbar-expand-lg
      align-items-center
      floating-nav
      navbar-light navbar-shadow
      custom-nav
    "
  >
    <div class="navbar-container d-flex content justify-content-between align-items-center">

      <!-- LEFT: Logo / Toggle / Company Name -->
      <NavbarLeft 
        :company="company"
        :show-mia-logo="showMiaLogo"
        :show-toggle="showToggle"
        :show-company-name="showCompanyName"
        :is-expanded="isExpanded"
      />

      <!-- CENTER & MOBILE MENU -->
      <NavbarMiddle 
        :show-middle-menu="showMiddleMenu"
        :show-profile-menu="showProfileMenu"
        :modules="modules"
        :company-id="company ? company.id : ''"
      />

      <!-- RIGHT: Action Icons -->
      <ul class="nav navbar-nav align-items-center right-nav-items">
        <DesktopSearch
          v-if="companyId && false"
        />
        <QuickAdd
            :modules="modules"
            v-if="companyId"
        />
        <Notifications
            v-if="companyId"
        />
        <ModulesGrid 
          :modules="modules"
          :company-id="company ? company.id : ''"
          v-if="companyId"
        />
        <UserProfile 
          :user="user"
          :profile="profile"
        />
      </ul>
    </div>
  </nav>
</template>

<script setup>
import { computed, watch } from "vue";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";
import handleSidebar from "@/services/modules/sidebar";
import NavbarLeft from "./components/NavbarLeft.vue";
import NavbarMiddle from "./components/NavbarMiddle.vue";
import DesktopSearch from "./components/DesktopSearch.vue";
import QuickAdd from "./components/QuickAdd.vue";
import Notifications from "./components/Notifications.vue";
import ModulesGrid from "./components/ModulesGrid.vue";
import UserProfile from "./components/UserProfile.vue";

const props = defineProps({
  showMiddleMenu:  { default: false },
  showCompanyName: { default: false },
  showToggle:      { default: false },
  showSetting:     { default: false },
  showMiaLogo:     { default: false },
  isExpanded:      { default: false },
  showProfileMenu: { default: false },
});

const store  = useStore();
const route  = useRoute();
const router = useRouter();

const { getModuleUrl } = handleSidebar();

const user    = computed(() => store.state.user.user);
const profile = computed(() => store.state.user.profile);
const company = computed(() => store.getters["company/getCompany"]);
const modules = computed(() => store.getters["company/getModules"]);

const isRouteProfile = computed(() => route.name === "profile");
const icon = computed(() => "fas fa-gear");
let companyId = route.params.companyId;

function logout() {
  localStorage.removeItem("user");
  localStorage.removeItem("token");
  localStorage.removeItem("X-Public-Token");
  localStorage.removeItem('lastCompanyId');
  localStorage.removeItem('lastModuleId');
  localStorage.removeItem('lastMenuId');
  router.push("/login");
}
</script>

<style scoped>
/* ─── Base ─────────────────────────────────────────────────────────────── */
.l-0 { left: 0 !important; }

.nav-custom,
.header-navbar {
  border-radius: 0 !important;
  height: 60px !important;
  min-height: 60px !important;
}

.navbar-container {
  padding: 0 1rem !important;
  height: 60px !important;
  min-height: 60px !important;
}

/* ─── Right nav items ────────────────────────────────────────────────── */
.right-nav-items { gap: 4px; flex-wrap: nowrap; }

@media (max-width: 767.98px) {
  .navbar-container { padding: 0 0.75rem !important; }
  .right-nav-items { gap: 2px; }
}

@media (max-width: 575.98px) {
  .nav-custom, .header-navbar { height: 56px !important; min-height: 56px !important; }
  .navbar-container { padding: 0 0.5rem !important; height: 56px !important; min-height: 56px !important; }
  .right-nav-items { gap: 0; }
}

.custom-nav {
    border-radius: 0;
}

</style>
